import { useEffect } from 'react'
import { useAppSelector } from 'state'
import { useUserInfo } from 'state/auth/hooks'
import { useCrisp } from './useCrisp'

function useCrispUser() {
  const { displayName, avatar } = useUserInfo()
  const tier = useAppSelector((state) => state.profile.tier)
  const crisp = useCrisp()

  useEffect(() => {
    if (!crisp) return

    try {
      if (displayName) {
        crisp.push(['set', 'user:nickname', [displayName]])
      }

      if (avatar) {
        crisp.push(['set', 'user:avatar', [avatar]])
      }

      if (tier?.id) {
        crisp.push(['set', 'session:data', ['vip_level', (tier.level - 1).toString()]])
      }
    } catch {
      console.error('Error push data crisp chat')
    }
  }, [displayName, avatar, crisp, tier])
}

export default useCrispUser
